import { useEffect, useState } from "react";
import BasicDropdown from "../../../ui library/components/dropdowns/BasicDropdown";

export default function Source({ initValue, repository, onChange }) {
  
  const [data, setData] = useState([]);

  const parseData = (items) =>
    items.map((item) => ({
      id: item.key,
      key: item.key,
      label: item.label,
    }));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await repository.query({
          content_type: "providerreferral",
          field_name: "source",
        });
        const mapped = parseData(response);
        setData(mapped);
      } catch (error) {
        throw error;
      }
    };

    fetchData();
  }, [repository]);

  return (
    <BasicDropdown
      initValue={initValue}
      label="Source"
      data={data}
      onValueChange={(_, value) => {
        onChange("source", value);
      }}
      addNoSelectionOption={true}
    />
  );
}
